import { FC } from "react";
import ColumnRowTable from
  "apps/website/components/feature/Table/ColumnRowTable/ColumnRowTable";

import { brandComparisonTableData } from "./shared/data";

export interface IBrandComparisonTableV2 {
  highlightKatKin?: boolean;
}

const BrandComparisonTableV2: FC<IBrandComparisonTableV2> = ({ highlightKatKin }) => (
  <ColumnRowTable
    component="BrandComparisonTableV2"
    highlightColumn={highlightKatKin ? 0 : undefined}
    columnTitles={brandComparisonTableData.titles}
    rows={brandComparisonTableData.rows}
    className="mx-auto"
    footer={brandComparisonTableData.footer}

  />
);

export default BrandComparisonTableV2;
